import { render, staticRenderFns } from "./QuickActionIcon.vue?vue&type=template&id=54f6db3e&scoped=true&lang=html&"
import script from "./QuickActionIcon.vue?vue&type=script&lang=js&"
export * from "./QuickActionIcon.vue?vue&type=script&lang=js&"
import style0 from "./QuickActionIcon.vue?vue&type=style&index=0&id=54f6db3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f6db3e",
  null
  
)

export default component.exports